export enum NewsTypesEnum {
  NEWS = 'NEWS',
  ANNOUNCEMENT = 'ANNOUNCEMENT',
}
